import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { SetUserPhoneNumberParams } from 'types/services';

export const setUserPhoneNumber = async (params: SetUserPhoneNumberParams) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
